import { useEffect, useLayoutEffect } from "react";

/**
 * `useLayoutEffect` that degrades to `useEffect` on the server.
 *
 * React logs a warning when `useLayoutEffect` runs during SSR ("does nothing on
 * the server"). Client-only UI that must update state BEFORE the browser paints
 * — e.g. blocking the wallet button the instant a coupon changes the price, so
 * the user never sees an interactive button bound to the stale intent — needs
 * layout timing on the client while staying quiet on the server.
 */
export const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
